import { useMutation } from 'react-query';

import {
  ValidateGiftRecipientParams,
  validateGiftRecipient,
} from '@utils/backend-api/groupSubscriptions';

export default function useValidateGiftRecipient() {
  const { mutate, mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (params: ValidateGiftRecipientParams) => validateGiftRecipient(params)
  );

  return { mutate, mutateAsync, isLoading, isError, isSuccess };
}
